var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"md":"1"}},[_vm._v(" "+_vm._s(_vm.companyName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }